import * as React from "react";
import { cn } from "cn";

const cardClass = "flex flex-col gap-4 rounded-2xl bg-card p-5 shadow-xs ring-1 ring-foreground/5";

function BriefCard({
  title,
  aside,
  heading = "card",
  className,
  children,
  ...props
}: Omit<React.ComponentProps<"section">, "title"> & {
  title: React.ReactNode;
  aside?: React.ReactNode;
  heading?: "card" | "section";
}) {
  return (
    <section className={cn(cardClass, "@container", className)} {...props}>
      <header className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <h2
          className={cn(
            "flex flex-1 items-center gap-2 text-foreground",
            heading === "section" ? "typo-h5" : "typo-label-lg"
          )}
        >
          {title}
        </h2>
        {aside}
      </header>
      {children}
    </section>
  );
}

export { BriefCard };
